import React from "react";
import { IconButton } from "@chakra-ui/react";
import { IoChatbubbleOutline } from "react-icons/io5";
import { ToolsConfig } from "duck";

interface CommentsProps {
  config: ToolsConfig;
}

const Comments: React.FC<CommentsProps> = ({ config }) => {
  const { mode, updateMode } = config;
  const isDisabledMode = mode === "disabled";

  return (
    <IconButton
      colorScheme="minor"
      aria-label="Comment"
      icon={<IoChatbubbleOutline />}
      isActive={isDisabledMode}
      onClick={() => updateMode(isDisabledMode ? "pen" : "disabled")}
    />
  );
};

export default Comments;
